/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TeamsControllerFindAllQueryResponse, TeamsControllerFindAllQueryParams, TeamsControllerFindAll401, TeamsControllerFindAll403 } from "../../models/teamsController/TeamsControllerFindAll";

function getTeamsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/teams` as const }  
  return res
}

/**
 * @summary Get all teams for the current user
 * {@link /api/v1/teams}
 */
export async function teamsControllerFindAll(params?: TeamsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TeamsControllerFindAllQueryResponse, ResponseErrorConfig<TeamsControllerFindAll401 | TeamsControllerFindAll403>, unknown>({ method : "GET", url : getTeamsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}